import { Component, OnInit,HostListener, OnDestroy,ElementRef,ViewChild } from '@angular/core';
import { ApiV2Service } from './services/api-v2.service';
import { ApiV1Service } from './services/api-v1.service';
import { InactivityService } from './services/inactivity.service'; 
import { ActivityTrackingService } from './services/activity-tracking.service';
import { Platform } from '@ionic/angular';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,ActivatedRoute } from '@angular/router';
import { firstValueFrom, timeout } from 'rxjs';
import { AppUpdateService } from './services/app-update.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  isOnline: boolean = navigator.onLine;
  show_change_password=false;
  loadingcp=false;
  model:any={};
  lastActivityTime: number = Date.now();
  // inactivityLimit = 28 * 60 * 1000; // 30 minutes in milliseconds
  inactivityLimit = 3 * 60 * 60 * 1000; // 3 hours
  checkActivityInterval!: any;
  sessionRefreshTimer: any;
  refreshTokenInterval: number = 10 * 60 * 1000; // 10 minutes
  showDropdown = false;
  public expandedIndex: number | null = null;
  isMenuOpen = false; // Tracks the visibility of the menu
  isSubMenuOpen = false;
  loading: boolean=false;
  returnUrl: string = '';

  public currentUser: any;
  public appPages = [
    { title: 'Inbox', url: '/folder/inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/spam', icon: 'warning' },
  ];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  public  MENUITEMS:any = [
    {
      label: 'master',
      main: [
        {
          state: 'dashboard',
          pid:31,
          short_label: 'D',
          name: 'Dashboard',
          type: 'link',
          icon: 'home',
          add:'nop',
          edit:'nop',
          delete:'nop'
        },
        {
          state: 'users',
          pid:17,
          short_label: 'U',
          name: 'Users',
          type: 'link',
          icon: 'person',
          add:'user_add',
          edit:'user_edit',
          delete:'user_delete'
        },
        {
          state: 'leads',
          pid:88,
          short_label: 'L',
          name: 'Leads',
          type: 'link',
          icon: 'trending-up',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
        },
        {
          state: 'customers',
          pid:13,
          short_label: 'C',
          name: 'Customers',
          type: 'link',
          icon: 'people',
          add:'customer-add',
          edit:'customer-edit',
          delete:'customer-delete'
        }, {
          state: 'cities',
          pid:62,
          short_label: 'C',
          name: 'Cities',
          type: 'link',
          icon: 'basket',
          add:'customer-add',
          edit:'customer-edit',
          delete:'customer-delete'
        },
        {
          state: 'citiestwo',
          pid:62,
          short_label: 'C',
          name: 'Cities Master 2',
          type: 'link',
          icon: 'basket',
          add:'citi-add',
          edit:'citi-edit',
          delete:'citi-delete'
        },
        {
          state: 'advocate-master',
          pid:94,
          short_label: 'A',
          name: 'Advocate Master',
          type: 'link',
          icon: 'briefcase',
          add:'advocate-add',
          edit:'advocate-edit',
          delete:'advocate-delete'
        },
        {
          state: 'region-master',
          pid:95,
          short_label: 'R',
          name: 'Region Master',
          type: 'link',
          icon: 'map',
          add:'region-add',
          edit:'region-edit',
          delete:'region-delete'
        },
        {
          state: 'metamaster',
          pid:70,
          short_label: 'M',
          name: 'Meta Master',
          type: 'link',
          icon: 'albums',
          add:'customer-add',
          edit:'customer-edit',
          delete:'customer-delete'
        },
        {
          state: 'venue-master',
          pid:112,
          short_label: 'V',
          name: 'Venue Master',
          type: 'link',
          icon: 'business',
          add:'venue-add',
          edit:'venue-edit',
          delete:'venue-delete'
        },/*
        {
          state: 'licensecategory',
          short_label: 'L',
          name: 'License Tarrifs',
          type: 'link',
          icon: 'ti-id-badge',
          add:'license_add',
          edit:'license_edit',
          delete:'license_delete'
        },*/
        {
          state: 'branch',
          pid:32,
          short_label: 'B',
          name: 'Local Fac. Centers',
          type: 'link',
          icon: 'swap-vertical',
          add:'branch_add',
          edit:'branch_edit',
          delete:'branch_delete'
        },
        {
          state: 'roles',
          pid:34,
          short_label: 'R',
          name: 'Roles',
          type: 'link',
          icon: 'person',
          add:'role_add',
          edit:'role_edit',
          delete:'role_delete'
        }
        // {
        //   state: 'setting',
        //   pid:81,
        //   short_label: 'S',
        //   name: 'Settings',
        //   type: 'link',
        //   icon: 'settings',
        //   add:'setting_add',
        //   edit:'setting_edit',
        //   delete:'setting_delete'
        // }
      ],
    },
    {
      label: 'Sales',
      main: [
        {
          state: 'quotation',
          pid:1,
          short_label: 'L',
          name: 'Proforma Invoices',
          type: 'link',
          icon: 'cart',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'one-window-pi',
          pid:89,
          short_label: 'L',
          name: 'Single Window PI',
          type: 'link',
          icon: 'cart',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'quotation/dr/sos',
          short_label: 'sos',
          pid:1,
          name: 'SOS License Requests',
          type: 'link',
          icon: 'document',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'license',
          pid:87,
          short_label: 'L',
          name: 'Licenses',
          type: 'link',
          icon: 'document',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'creditnote',
          pid:66,
          short_label: 'CN',
          name: 'Credit Notes',
          type: 'link',
          icon: 'card',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
      /*  
        {
          state: 'invoice',
          short_label: 'I',
          name: 'Invoices',
          type: 'sub',
          icon: 'ti-layers-alt',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete',
          children: [  {
              state: 'summary',
              name: 'Invoice Summary'
            }, {
              state: 'list',
              name: 'Invoice List'
            }
          ]
        
        },*/
        {
          state: 'transactions',
          pid:5,
          short_label: 'T',
          name: 'Transactions',
          type: 'link',
          icon: 'cash',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'bankstatement',
          short_label: 'bs',
          pid:20,
          name: 'Bank Statement',
          type: 'link',
          icon: 'business',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'refund-transactions',
          short_label: 'rt',
          pid:9,
          name: 'Refund Transactions',
          type: 'link',
          icon: 'cash',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        // {
        //   state: 'requests',
        //   pid:25,
        //   short_label: 'R',
        //   name: 'All Requests',
        //   type: 'link',
        //   icon: 'reader',
        //   add:'invoice_add',
        //   edit:'invoice_edit',
        //   delete:'invoice_delete'
        // },
        {
          state: 'legal-notice',
          pid: 93,
          short_label: 'LN',
          name: 'Legal Notice',
          type: 'link',
          icon: 'document-text',
          add: 'invoice_add',
          edit: 'invoice_edit',
          delete: 'invoice_delete'
        },
        {
          state: 'quotation/dr/dr',
          state1: 'dr',
          state2: 'dr',
          short_label: 'dr',
          pid:24,
          name: 'Discount Requests',
          type: 'link',
          icon: 'gift',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }, 
        {
          state: 'cart-discount-request',
          state1: 'dr',
          state2: 'dr',
          short_label: 'dr',
          pid:24,
          name: 'Cart Discount Requests',
          type: 'link',
          icon: 'gift',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }, 
        {
          state: 'quotation/dr/atir',
          pid:25,
          short_label: 'atir',
          name: 'Advance TI Requests',
          type: 'link',
          icon: 'reader',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }, 
        {
          state: 'quotation/dr/pir',
          pid:25,
          short_label: 'pir',
          name: 'PI Requests',
          type: 'link',
          icon: 'id-card',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }, 
        {
          state: 'quotation/dr/noc',
          pid:78,
          short_label: 'noc',
          name: 'Extension NOC Requests',
          type: 'link',
          icon: 'cart',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'noc-foc',
          pid:78,
          short_label: 'noc-foc',
          name: 'NOC FOC Requests',
          type: 'link',
          icon: 'cart',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'quotation/dr/cpn',
          short_label: 'dr',
          pid:86,
          name: 'Customer PAN Requests',
          type: 'link',
          icon: 'card',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }, 
        {
          state: 'einvoicect',
          pid:84,
          short_label: 'E',
          name: 'Einvoice CT Log',
          type: 'link',
          icon: 'receipt',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        },
        {
          state: 'report',
          pid:26,
          short_label: 'report',
          name: 'Reports',
          type: 'link',
          icon: 'archive',
          add:'invoice_add',
          edit:'invoice_edit',
          delete:'invoice_delete'
        }
        /*,
        {
          state: 'dtoc',
          pid:27,
          short_label: 'dtoc',
          name: 'D2C',
          type: 'link',
          icon: 'ti-archive',
          add:'dtoc_add',
          edit:'dtoc_edit',
          delete:'dtoc_delete'
        }*/
  
      ]
    },
    {
      label: 'DART',
      main: [  {
        state: 'tracking',
        pid:74,
        short_label: 'T',
        name: 'Tracking',
        type: 'link',
        icon: 'analytics',
        add:'settings_add',
        edit:'settings_edit',
        delete:'settings_delete'
      //   target: true
      },
        // {
          // state: 'document',
          // pid:46,
          // short_label: 'D',
          // name: 'Documents',
          // type: 'link',
          // icon: 'folder',
          // add:'settings_add',
          // edit:'settings_edit',
          // delete:'settings_delete'
        //   target: true
        // },
        // {
        //   state: 'leadstatus',
        //   short_label: 'L',
        //   pid:50,
        //   name: 'Lead Statuses',
        //   type: 'link',
        //   icon: 'pricetag',
        //   add:'settings_add',
        //   edit:'settings_edit',
        //   delete:'settings_delete'
        //   // target: true
        // },
        {
          state: 'target',
          short_label: 'T',
          pid:54,
          name: 'Sales Targets',
          type: 'link',
          icon: 'ti-stats-up',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
        }, 
        {
          state: 'incentive',
          short_label: 'I',
          pid:58,
          name: 'Incentives',
          type: 'link',
          icon: 'ti-split-v-alt',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
        }
  
      ]
    },
  
   /* 
    {
      label: 'Settings',
      main: [
        {
          state: 'system-config',
          short_label: 'S',
          name: 'System config',
          type: 'link',
          icon: 'ti-settings',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
        //   target: true
        },
        {
          state: 'maintainance',
          short_label: 'M',
          name: 'Maintainance',
          type: 'link',
          icon: 'ti-na',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
          // target: true
        }
      ]
    },*/
    /*{
      label: 'Support',
      main: [
        {
          state: 'tickets',
          short_label: 'S',
          name: 'Tickets',
          type: 'link',
          icon: 'ti-layout-list-post',
          add:'settings_add',
          edit:'settings_edit',
          delete:'settings_delete'
          // target: true
        }
      ]
    }*/
  ];
  userAccounts: any;
  constructor(public apiService:ApiV2Service,public apiV1Sevice:ApiV1Service, private router: Router,private route: ActivatedRoute,private inactivityservice:InactivityService,private activityTracking: ActivityTrackingService,public platform:Platform,private appUpdate: AppUpdateService) {


    this.platform.ready().then(() => {
      this.inactivityservice.initialize();
      this.activityTracking.setMenuItems(this.MENUITEMS);
      this.activityTracking.initialize();
    });

       
  }

  

  can_show_menu(label){ 
   
    return true;
  }

  onlineHandler = () => {
    this.isOnline = true;
    console.log('✅ Back Online');
  };

  offlineHandler = () => {
    this.isOnline = false;
    console.log('❌ No Internet, Or Low Connectivity');
  };

  ngOnInit(){
    this.appUpdate.init();

        // Initial check
        this.isOnline = navigator.onLine;

        // Add listeners
        window.addEventListener('online', this.onlineHandler);
        window.addEventListener('offline', this.offlineHandler);
        console.log(this.apiService.currentUserValue ,'Current user value');

        const activeEmail = localStorage.getItem('active_account');
        const v1 = this.apiService.currentUserValue?.v1_data;
        if (activeEmail && v1) {
          this.apiService.storeV1Profile(activeEmail, v1);
        }

    
        
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
console.log("console 1",this.apiService.currentUserValue);
    setTimeout(()=>{
      this.get_set_refresh();
      //console.log('abcd');
    },5000);

    // this.sessionRefreshTimer = setInterval(()=>{
    //   this.get_set_refresh();
    //   //console.log('abcd');
    // },900000);

    

 //this.startInactivityCheck();
 this.apiV1Sevice.list_licensecategory().subscribe(res=>{
  console.log('abc');
 })
 
  }

  get_set_refresh(){
    if (localStorage.getItem('reauth_required') || sessionStorage.getItem('reauth_required')) {
      return;
    }
    console.log("console 2",this.apiService.currentUserValue);
      if(this.apiService.currentUserValue?.id){

        console.log(localStorage.getItem('active_account'));

        let emailactive= localStorage.getItem('active_account'); 
      let active_accounts=this.getActiveAccount(emailactive);
      const refreshToken = active_accounts?.refresh_token || localStorage.getItem('refresh_token');
      if (refreshToken) {
        this.apiService.getSetCurrentUser(refreshToken);
      }
        // console.log(this.apiService.getSetCurrentUser(active_accounts.refresh_token));
          console.log('Anil');
          // console.log(this.apiService.currentUserValue.v1_data);

        //this.autologout();

        } else{

          //this.autologout();
         let us= localStorage.getItem('currentUser');

          console.log('not logged in', us);
      }
  }

  

  
  ngOnDestroy() {
    // Remove listeners to prevent memory leaks
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);

    if (this.checkActivityInterval) {
      clearInterval(this.checkActivityInterval);
    }
    if (this.sessionRefreshTimer) {
      clearInterval(this.sessionRefreshTimer);
    }
  }


  startInactivityCheck() {
console.log('statr hostlistner');
  if (this.checkActivityInterval) {
    clearInterval(this.checkActivityInterval);
  }
this.checkActivityInterval =  setInterval(()=>{

  let  tempcu=localStorage.getItem('currentUser');
  if(tempcu){
    this.currentUser = JSON.parse(tempcu);
  }
    

    if(this.currentUser){
      this.checkInactivityAndRefresh();

    }

  
  
},this.refreshTokenInterval);

}


  checkInactivityAndRefresh() {
    const now = Date.now();
    let inactiveTime = 0;
    //inactiveTime = now - this.lastActivityTime;

    const storedTime = localStorage.getItem('lastActivity');
    const lastTime = storedTime ? parseInt(storedTime, 10) : this.lastActivityTime;
    inactiveTime = now - lastTime;

    console.log(inactiveTime , this.inactivityLimit + ' inactivetimeer ', this.lastActivityTime , lastTime);
  
    if (inactiveTime > this.inactivityLimit) {
      
      clearInterval(this.checkActivityInterval);

      this.autologout();
      
     

    } else{
      let emailactive= localStorage.getItem('active_account'); 
      let active_accounts=this.getActiveAccount(emailactive);
      const refreshToken =
        active_accounts?.refresh_token || localStorage.getItem('refresh_token');
      if (refreshToken) {
        this.apiService.getSetCurrentUser(refreshToken);
      }
    }
  }


  async logout(){
    this.apiService.presentAlertConfirm('Logout','Are you sure you want to log out?','log out').then(async (res:any)=>{
      if(res){
         clearInterval(this.checkActivityInterval);
         this.inactivityservice.cleanup();
         // Manual logout → save logout_at + logout_type = MANUAL
         await this.activityTracking.trackLogout('MANUAL');
         this.apiService.autologout('/', '', 'MANUAL');
            }
          
        });
    }

    async autologout(logoutType: string = 'IDLE_3HR'){
      clearInterval(this.checkActivityInterval);
      this.inactivityservice.cleanup();
      // Idle / other forced logout — default IDLE_3HR
      await this.activityTracking.trackLogout(logoutType || 'IDLE_3HR');
      this.apiService.autologout('/auth', '', logoutType || 'IDLE_3HR');
    }
      can_show_submenu(label){
        // console.log(label);
         //return true;
         //label in asidemenu
        //console.log(this.commonService.getCurrentUser());
    //console.log(this.authService.checkPermission(label.pid));
        if(this.apiV1Sevice.checkPermission(label.pid)){
          return true;
        }
        else {
        return false;
        }
      }


  toggleMenu() {
    const splitPane :any= document.querySelector('ion-split-pane');
    const windowWidth = window.innerWidth;
    const splitPaneShownAt = 992;
    const when = `(min-width: ${splitPaneShownAt}px)`;
    if (windowWidth >= splitPaneShownAt) {
      // split pane view is visible
      const open = splitPane.when === when;
      splitPane.when = open ? false : when;
    } else {
      // split pane view is not visible
      // toggle menu open
      const menu = splitPane.querySelector('ion-menu');
      return menu.open();
    }
  }


  formSubmitChangePassword($event) {
    // console.log(this.model);
    this.model.isPasswordchange = true; 
     //change password api call here
    //  console.log(this.model);
     
     if(this.model.confirm_password && this.model.npassword){
      if(this.model.npassword != this.model.confirm_password){
        this.apiService.present_toast('danger','Password Not Matching');
        return 0;
      }
      if(this.model.npassword.length  > 4){
        this.loadingcp=true;
        let newPassword = this.model.npassword;
       
        this.apiService.changePassword(newPassword).subscribe({
          next: (res) => {
            console.log('Password changed successfully', res);
            this.apiService.present_toast('info','Password Changed successfully');
            this.loadingcp = false;
            this.show_change_password = false;
            setTimeout(() => {
              this.autologout('MANUAL');
            }, 1000); // 2000ms = 2s
          
          },
          error: (err) => {
            console.error('Error changing password:', err);
          }
        });

      }
      else {
        this.apiService.present_toast('info','Password too short');
      }
     }
     else {
       this.apiService.present_toast('info','Please fill all Fields');
     }
    
  }

  getRouterLink(state: string) {
    return '/'+state;
  }
 // Close dropdown when clicking anywhere outside the dropdown itself
@HostListener('document:click', ['$event'])

handleDocumentClick(event: Event) {
  const target = event.target as HTMLElement;
  const clickedInsideDropdown = this.dropdownMenu?.nativeElement.contains(target);
  const clickedUserIcon = target.closest('ion-button[fill="clear"]'); // the user icon button

  if (!clickedInsideDropdown && !clickedUserIcon) {
    // Clicked anywhere else — close dropdown
    this.showDropdown = false;
  }
}

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  openChangePassword() {
    this.showDropdown = false;
    this.show_change_password = true;
  }

  toggleSubMenu() {
    this.isSubMenuOpen = !this.isSubMenuOpen;

    this.loadUserAccounts();
  }

  async loadUserAccounts() {
    if (!this.apiService.currentUserValue?.v1_data) {
      console.error("Current user data is missing.");
      return;
    }
  
  
    try {
if(!this.userAccounts){
      let params="is_primary="+this.apiService.currentUserValue?.v1_data.is_primary;
      params=params+'&id='+this.apiService.currentUserValue?.v1_data.id;
      if(this.apiService.currentUserValue?.v1_data.is_primary==0){
        params=params+'&parent_ids='+this.apiService.currentUserValue?.v1_data.parent_user_id;
      }
      const res = await firstValueFrom(this.apiV1Sevice.list_useralias(params));
      this.userAccounts = Array.isArray(res) ? res : [];

      // Sort: Primary account first, then others
      this.userAccounts.sort((a:any, b:any) => {
        return b.is_primary - a.is_primary; // Primary (1) comes before Non-Primary (0)
      });

      console.log("Sorted User Accounts:", this.userAccounts);

    }else{
      return this.userAccounts;
    }
     
    } catch (error) {
      console.error("Error fetching user accounts:", error);
    }
  }


  getActiveAccount(email) {
    const accounts = JSON.parse(localStorage.getItem('accounts') || '[]');
    const activeEmail = email;
    return accounts.find((acc: any) => acc.email === activeEmail);
  }

  isCurrentActiveAccount(user: any): boolean {
    return !!user?.email && user.email === localStorage.getItem('active_account');
  }

  async switchAccount(user: any) {
    const targetEmail = user?.email;
    if (!targetEmail) {
      await this.apiService.present_toast('error', 'Could not switch account: missing email.');
      return;
    }

    if (targetEmail === localStorage.getItem('active_account')) {
      this.isSubMenuOpen = false;
      this.isMenuOpen = false;
      return;
    }

    if (sessionStorage.getItem('account_switch_in_progress')) {
      return;
    }

    this.isSubMenuOpen = false;
    this.isMenuOpen = false;

    const previousActive = localStorage.getItem('active_account');
    const outgoing = this.apiService.currentUserValue?.v1_data
      ? { ...this.apiService.currentUserValue.v1_data }
      : null;
    const outgoingEmail = previousActive || outgoing?.email || '';
    sessionStorage.setItem('account_switch_in_progress', '1');
    sessionStorage.setItem('account_switch_grace', String(Date.now() + 30000));

    try {
      // 1) Open target account FIRST (do not close previous yet — that broke switch)
      this.clearDirectusCookie();
      localStorage.setItem('active_account', targetEmail);

      let switched = false;
      const cached = this.getActiveAccount(targetEmail);
      if (cached?.refresh_token) {
        try {
          const restored = await this.apiService.getSetCurrentUser(cached.refresh_token);
          if (restored) {
            switched = true;
          }
        } catch (e) {
          console.warn('Account switch refresh failed, will try alias login', e);
        }
      }

      if (!switched) {
        const loggedIn = await this.loginAliasAccount(user);
        if (loggedIn) {
          switched = true;
        }
      }

      if (!switched) {
        if (previousActive) {
          localStorage.setItem('active_account', previousActive);
        }
        await this.apiService.present_toast(
          'error',
          'Failed to switch account. Please try again.'
        );
        return;
      }

      // 2) Open V1 session for the new alias (best-effort)
      await this.attachV1ProfileForSwitch(user);

      // 3) Close previous V1 session AFTER new account is ready
      if (outgoing?.token) {
        try {
          await firstValueFrom(
            this.apiV1Sevice.logout('ACCOUNT_SWITCH', outgoing).pipe(timeout(8000))
          );
        } catch (e) {
          // Do not block switch — new account is already active
          console.warn('Outgoing ACCOUNT_SWITCH logout failed (non-blocking)', e);
        }
        if (outgoingEmail) {
          this.apiService.removeV1Profile(outgoingEmail);
        }
      } else if (outgoingEmail) {
        this.apiService.removeV1Profile(outgoingEmail);
      }

      this.userAccounts = null;
      try {
        sessionStorage.removeItem('account_switch_in_progress');
      } catch {
        /* ignore */
      }
      this.activityTracking.trackAccountSwitch({
        fromEmail: outgoingEmail,
        toEmail: targetEmail,
        fromId: outgoing?.id,
        toId: user?.id || this.apiService.currentUserValue?.v1_data?.id,
      });
      this.inactivityservice.resetAfterLogin();
      this.finishAccountSwitchReload();
    } finally {
      sessionStorage.removeItem('account_switch_in_progress');
    }
  }

  /** Load alias V1 token/profile without overwriting Directus session in localStorage. */
  async attachV1ProfileForSwitch(v1User: any): Promise<boolean> {
    let profile = { ...v1User };
    const email = profile.email || localStorage.getItem('active_account');
    if (!profile.token && email) {
      const aliasPassword = this.getAliasPassword(profile);
      try {
        const v1Res = await firstValueFrom(
          this.apiV1Sevice.fetchLoginProfile(email, aliasPassword)
        );
        if (v1Res?.token) {
          profile = { ...profile, ...v1Res, token: v1Res.token };
        }
      } catch (e) {
        console.warn('V1 profile sync for switched account failed', e);
      }
    }

    if (!profile?.token) {
      console.warn('Account switch: V1 token not ready for target alias yet');
      return false;
    }

    this.apiService.mergeV1Profile(profile);
    return !!this.apiService.currentUserValue?.v1_data?.token;
  }

  finishAccountSwitchReload(): void {
    sessionStorage.setItem('account_switch_grace', String(Date.now() + 15000));
    window.location.reload();
  }

  clearDirectusCookie() {
    document.cookie = 'directus_refresh_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  /** Directus login for alias when no cached refresh token exists. */
  async loginAliasAccount(user: any): Promise<boolean> {
    this.loading = true;
    const aliasPassword = this.getAliasPassword(user);
    const params = { email: user.email, password: aliasPassword };

    try {
      await firstValueFrom(this.apiService.auth('login', params));
      return !!this.apiService.currentUserValue?.session?.access_token;
    } catch (error) {
      console.error('Alias login failed:', error);
      return false;
    } finally {
      this.loading = false;
    }
  }

  /**
   * Alias password for Directus/V1 attach.
   * Prefer listalias `aliasname` (unique password); fall back to legacy default
   * used when aliasname was never stored (older primary/alias pairs).
   */
  getAliasPassword(user: any): string {
    const fromList = String(user?.aliasname || '').trim();
    if (fromList) {
      return fromList;
    }
    return '123456';
  }



}
